(function($){
	
	/*$(document).ready(function(){ 		
	});*/


/* --------------------- EXECUTER A L'ACTION ------------------------------*/
	
	/* On ouvre tous les liens externes dans un nouvel onglet */
	$('a').each(function(index, elem){
		var a = new RegExp('/'+window.location.host+'/');
		if(!a.test(this.href)) $(this).attr('target', '_blank');
	}); 


	/* On considère tous les liens #... comme des ancres douces */
	//$('a[href^="#"]').on('click', function(e){
	$('a.ancre').on('click', function(e){
		e.preventDefault();
		var href = $(this).attr('href');
		var elem = $(href);
		if( elem.length ){
			var elemTop = elem.first().offset().top;
			$('html,body').animate({
				scrollTop:elemTop
			}, "fast");
		}
	});


	/* Permet d'ajouter un bouton de retour */	
	$('.retour').on('click', function(e) {
        e.preventDefault();
    	window.history.back();
	});


	/* Pour le bouton de la version responsive */
	$('.burger_bouton').on('click', function(event){
		event.preventDefault();
		if ( $('.burger_bouton').hasClass('open') ){
			$('.burger_bouton, nav').removeClass('open');
			$('.burger-top, .burger-middle, .burger-bottom, .burger-croix, .burger_menu').removeClass('click');
		} else {
			$('.burger_bouton, nav').addClass('open');
			$('.burger-top, .burger-middle, .burger-bottom, .burger-croix, .burger_menu').addClass('click');
		}
	});



})(jQuery);